import React, { useEffect, useState } from "react";
import moment from "moment";
import PageHeader from "../common/PageHeader";
import Loader from "../common/Loader";
import EmptyState from "../common/EmptyState";
import { getNotifications } from "../../api/common";

export default function Notifications() {
	const [loading, setLoading] = useState(true);
	const [notifications, setNotifications] = useState([]);

	useEffect(() => {
		(async () => {
			setLoading(true);
			const res = await getNotifications();
			if (res && res.notifications && !res.notifications.error) setNotifications(res.notifications.data || []);
			setLoading(false);
		})();
	}, []);

	return (
		<div>
			<PageHeader title="Message notifications" subtitle="Updates on your bids, orders and deliveries" />
			{loading ? (
				<Loader />
			) : notifications.length === 0 ? (
				<EmptyState title="You're all caught up" subtitle="New updates about your orders will show up here." />
			) : (
				<div className="card">
					<ul className="list-unstyled m-0">
						{notifications.map((n, idx) => (
							<li key={n._id || idx} className={`d-flex justify-content-between align-items-start px-4 py-3 border-bottom${n.isRead === false ? " notif-unread" : ""}`}>
								<div>
									<div className="fw-semibold">{n.title || n.type || "Notification"}</div>
									<div className="text-muted small">{n.description || n.message || n.body}</div>
								</div>
								<div className="text-muted small text-nowrap ms-3">{n.createdAt ? moment(n.createdAt).fromNow() : ""}</div>
							</li>
						))}
					</ul>
				</div>
			)}
		</div>
	);
}
